<template>
  <div class="textArea">
    <h3>プロフィール</h3>
    <ul>
      <li>エネルギー科学修士（Master of Energy Science, Kyoto Univ. 2018）</li>
      <li>AI/IoTエンジニア（Skillsをご覧ください）</li>
      <li>趣味webデベロッパー</li>
      <li>YBR125ライダー</li>
      <li>乗り鉄</li>
      <li>デレステP（桃華、千枝、雪美担当）</li>
    </ul>
    
    <h3>Contact</h3>
    <ul>
      <li>ブログ：<a href=https://bluepost69.hatenablog.com/>https://bluepost69.hatenablog.com/</a></li>
      <li>twitter：<a href=https://twitter.com/Bluepost125>@bluepost125</a></li>
    </ul>

  </div>
</template>

<script>

export default {
  name: 'Home',
}
</script>

<style scoped>
div.textArea{
  background: #ffffff;
  text-align:left;
  vertical-align: top;
  padding:10px;
  margin: 10px 0px 10px 0px;
}
</style>